import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../../../config/queryKeys'
import { getPlayerDetailsTables } from '../../../../../services/player/playerDetailsTables'
import { mapPlayerDetailsTables } from '../utils/mapPlayerDetailsTables'

/**
 * The Player Details tables for one player: GET /players/:id/details, mapped
 * to the rows each table shows. The raw response is what is cached.
 */
export const usePlayerDetailsTables = (playerId: string | undefined) =>
  useQuery({
    queryKey: queryKeys.playerDetails.byId(playerId),
    queryFn: () => getPlayerDetailsTables(playerId as string),
    enabled: Boolean(playerId),
    select: mapPlayerDetailsTables,
  })
